module.exports = __webpack_public_path__ + "img/27.e1fd7d0a.jpg";